import { useEffect } from 'react';
import { useBoundStore } from '@Store/useBoundStore';
import type { ExtendedUseFormReturn } from './useFormHooks';
import type { FieldValues, Path } from 'react-hook-form';
import type { OnboardingFormFields } from '@Types/types';

interface ISetErrorsProps<T extends FieldValues> {
  formMethods: ExtendedUseFormReturn<T>;
}
const useSetError = <T extends FieldValues>(props: ISetErrorsProps<T>) => {
  const { formMethods } = props;
  const { formFieldErrors } = useBoundStore((state) => state.errorSlice);
  useEffect(() => {
    const activeErrorObjects: [OnboardingFormFields, string][] = Object.entries(
      formFieldErrors
    ).filter((entry) => entry && entry[1] !== '') as [OnboardingFormFields, string][];

    activeErrorObjects.forEach(([formField, errorMessage]) => {
      formMethods.setError(formField as Path<T>, { message: errorMessage });
      const input = document.getElementById(formField);
      if (input) {
        input.focus();
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }, [formFieldErrors]);
};
export default useSetError;
